import type {
  BrowserKeyManifest,
  ArityId,
} from "@stealthos/joinsplit-prover-wasm";

export function preparePublicKeyCache(
  manifest: BrowserKeyManifest,
  arity: ArityId,
  base: string,
  signal?: AbortSignal,
): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new DOMException("Cancelled", "AbortError"));
      return;
    }
    const worker = new Worker(
      new URL("./publicKeyCache.worker.ts", import.meta.url),
      { type: "module", name: "stealthos-public-data" },
    );
    const finish = (error?: Error) => {
      clearTimeout(timer);
      signal?.removeEventListener("abort", abort);
      worker.terminate();
      error ? reject(error) : resolve();
    };
    const abort = () => finish(new DOMException("Cancelled", "AbortError"));
    const timer = setTimeout(
      () =>
        finish(
          new Error(
            "Preparing transaction took too long. No transaction was sent. Please try again.",
          ),
        ),
      65_000,
    );
    signal?.addEventListener("abort", abort, { once: true });
    worker.onmessage = (event) =>
      finish(
        event.data?.ok
          ? undefined
          : new Error(
              "Could not load transaction data. No transaction was sent. Please try again.",
            ),
      );
    worker.onerror = () =>
      finish(
        new Error("Could not prepare this transaction. Please try again."),
      );
    worker.postMessage({
      entry: manifest.keys.find((key) => key.arity_id === arity),
      circuitVersion: manifest.statement.circuit_version,
      base,
    });
  });
}
